<template>
	<el-time-picker
		ref="input"
		class="input-sigarus-time-picker"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
	/>
</template>

<script>
	export default {
		name: 'InputSigarusTimePicker',
		props: {
			value: {
				default: ''
			},
			pickerOptions: {
				type: Object,
				default: () => ({
					selectableRange: '00:00:00 - 23:59:59'
				})
			},
			valueFormat: {
				type: String,
				default: 'HH:mm:ss'
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) }

		}
	}
</script>
